import Route from '@ember/routing/route';

class AppsRoute extends Route {
  titleToken = 'Apps';
}

export default AppsRoute;
